/** localStorage key for admin session timeout (minutes). 0 = never. */
export const ADMIN_SESSION_TIMEOUT_KEY = 'magia_admin_session_timeout_minutes';

export function getSessionTimeoutMinutes(): number {
  if (typeof window === 'undefined') return 0;
  const v = localStorage.getItem(ADMIN_SESSION_TIMEOUT_KEY);
  if (v === null) return 0;
  const n = parseInt(v, 10);
  return Number.isNaN(n) ? 0 : Math.max(0, n);
}

export function setSessionTimeoutMinutes(minutes: number): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(ADMIN_SESSION_TIMEOUT_KEY, String(Math.max(0, minutes)));
}
